export const subscribeChannel = {
  candleStickSubscribe: 'candlestick',
  tokenInfoSubscribe: 'token_info',
  simpleTokenInfoSubscribe: 'simple_token_info',
  orderResultSubscribe: 'order_result',
} as const;
